import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Unit_instancev9v8hjid95df as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { Phases_getInstance3nx89wd8botnl as Phases_getInstance } from '../statement/HttpResponsePipeline.mjs';
import { get_isTraceEnabled82xibuu04nxp as get_isTraceEnabled } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/Logger.web.mjs';
import { save1y71vsgu0wj47 as save } from '../call/SavedCall.mjs';
import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result__exceptionOrNull_impl_p6xea9318j6pdzpd0vd as Result__exceptionOrNull_impl_p6xea9,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { canceldn4b3cdqcfny as cancel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  createClientPlugin16sdkdabbewya as createClientPlugin,
  createClientPluginjwpvufjows5r as createClientPlugin_0,
} from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_SKIP_SAVE_BODY() {
  _init_properties_SaveBody_kt__lbc3fj();
  return SKIP_SAVE_BODY;
}
var SKIP_SAVE_BODY;
function get_RESPONSE_BODY_SAVED() {
  _init_properties_SaveBody_kt__lbc3fj();
  return RESPONSE_BODY_SAVED;
}
var RESPONSE_BODY_SAVED;
function get_LOGGER() {
  _init_properties_SaveBody_kt__lbc3fj();
  var tmp0 = LOGGER$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('LOGGER', 0, tmp, _get_LOGGER_$ref_77hhxy(), null);
  return tmp0.n3();
}
var LOGGER$delegate;
function get_SaveBody() {
  _init_properties_SaveBody_kt__lbc3fj();
  return SaveBody;
}
var SaveBody;
var SaveBodyPlugin;
function get_isSaved(_this__u8e3s4) {
  _init_properties_SaveBody_kt__lbc3fj();
  return _this__u8e3s4.v5j().p5j().c4n(get_RESPONSE_BODY_SAVED());
}
var SaveBodyPluginConfigClass;
function SaveBodyPluginConfig() {
  if (SaveBodyPluginConfigClass === VOID) {
    class $ {
      constructor() {
        this.s5v_1 = false;
      }
    }
    initMetadataForClass($, 'SaveBodyPluginConfig', SaveBodyPluginConfig);
    SaveBodyPluginConfigClass = $;
  }
  return SaveBodyPluginConfigClass;
}
function skipSaveBody(_this__u8e3s4) {
  _init_properties_SaveBody_kt__lbc3fj();
  _this__u8e3s4.c5j_1.d4n(get_SKIP_SAVE_BODY(), Unit_instance);
}
function LOGGER$delegate$lambda() {
  _init_properties_SaveBody_kt__lbc3fj();
  return KtorSimpleLogger('io.ktor.client.plugins.SaveBody');
}
function _get_LOGGER_$ref_77hhxy() {
  return () => get_LOGGER();
}
function SaveBody$lambda($this$createClientPlugin) {
  _init_properties_SaveBody_kt__lbc3fj();
  var tmp = Phases_getInstance().z5n_1;
  $this$createClientPlugin.d5o_1.j5h_1.s4s(tmp, SaveBody$lambda$slambda_0());
  return Unit_instance;
}
var SaveBody$lambda$slambdaClass;
function SaveBody$lambda$slambda() {
  if (SaveBody$lambda$slambdaClass === VOID) {
    class $ {
      *x5n($this$intercept, response, $completion) {
        var call = response.v5j();
        var attributes = call.p5j();
        if (attributes.c4n(get_SKIP_SAVE_BODY())) {
          // Inline function 'io.ktor.util.logging.trace' call
          var this_0 = get_LOGGER();
          if (get_isTraceEnabled(this_0)) {
            var tmp$ret$1 = 'Skipping body saving for ' + call.o5j().x5j().toString();
            this_0.s4t(tmp$ret$1);
          }
          return Unit_instance;
        }
        var tmp;
        try {
          // Inline function 'io.ktor.util.logging.trace' call
          var this_1 = get_LOGGER();
          if (get_isTraceEnabled(this_1)) {
            var tmp$ret$3 = 'Saving body for ' + call.o5j().x5j().toString();
            this_1.s4t(tmp$ret$3);
          }
          tmp = (yield* save(call, $completion)).t5h();
        }finally {
          // Inline function 'kotlin.runCatching' call
          var tmp_0;
          try {
            cancel(response.d5k());
            // Inline function 'kotlin.Companion.success' call
            tmp_0 = _Result___init__impl__xyqfz8(Unit_instance);
          } catch ($p) {
            var tmp_1;
            if ($p instanceof Error) {
              var e = $p;
              // Inline function 'kotlin.Companion.failure' call
              tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
            } else {
              throw $p;
            }
            tmp_0 = tmp_1;
          }
          // Inline function 'kotlin.onFailure' call
          var this_2 = tmp_0;
          var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(this_2);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            get_LOGGER().r4t('Failed to cancel response body', tmp0_safe_receiver);
          }
        }
        var savedResponse = tmp;
        attributes.d4n(get_RESPONSE_BODY_SAVED(), Unit_instance);
        yield* $this$intercept.q4r(savedResponse, $completion);
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.x5n(tmp, p2 instanceof HttpResponse() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    SaveBody$lambda$slambdaClass = $;
  }
  return SaveBody$lambda$slambdaClass;
}
function SaveBody$lambda$slambda_0() {
  var i = new (SaveBody$lambda$slambda())();
  var l = ($this$intercept, response, $completion) => i.x5n($this$intercept, response, $completion);
  l.$arity = 2;
  return l;
}
function SaveBodyPluginConfig$_init_$ref_lwjaof() {
  var l = () => new (SaveBodyPluginConfig())();
  l.callableName = '<init>';
  return l;
}
function SaveBodyPlugin$lambda($this$createClientPlugin) {
  _init_properties_SaveBody_kt__lbc3fj();
  if ($this$createClientPlugin.e5o_1.s5v_1) {
    get_LOGGER().q4t('It is no longer possible to disable body saving for all requests. Use client.prepareRequest(...).execute { ... } syntax to prevent saving the body in memory.\n\nThis API is deprecated and will be removed in Ktor 4.0.0\nIf you were relying on this functionality, share your use case by commenting on this issue: https://youtrack.jetbrains.com/issue/KTOR-8367/');
  } else {
    get_LOGGER().q4t('The SaveBodyPlugin plugin is deprecated and can be safely removed. Request bodies are now saved in memory by default for all non-streaming responses.');
  }
  return Unit_instance;
}
var properties_initialized_SaveBody_kt_hzvee7;
function _init_properties_SaveBody_kt__lbc3fj() {
  if (!properties_initialized_SaveBody_kt_hzvee7) {
    properties_initialized_SaveBody_kt_hzvee7 = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'SkipSaveBody';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(Unit());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(Unit()), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$2);
    SKIP_SAVE_BODY = new (AttributeKey())(name, tmp$ret$1);
    // Inline function 'io.ktor.util.AttributeKey' call
    var name_0 = 'ResponseBodySaved';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_2 = getKClass(Unit());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_3;
    try {
      tmp_3 = createKType(getKClass(Unit()), arrayOf([]), false);
    } catch ($p) {
      var tmp_4;
      if ($p instanceof Error) {
        var _unused_var__etf5q3_0 = $p;
        tmp_4 = null;
      } else {
        throw $p;
      }
      tmp_3 = tmp_4;
    }
    var tmp$ret$2_0 = tmp_3;
    var tmp$ret$1_0 = new (TypeInfo())(tmp_2, tmp$ret$2_0);
    RESPONSE_BODY_SAVED = new (AttributeKey())(name_0, tmp$ret$1_0);
    LOGGER$delegate = lazy(LOGGER$delegate$lambda);
    SaveBody = createClientPlugin('SaveBody', SaveBody$lambda);
    var tmp_5 = SaveBodyPluginConfig$_init_$ref_lwjaof();
    SaveBodyPlugin = createClientPlugin_0('DoubleReceivePlugin', tmp_5, SaveBodyPlugin$lambda);
  }
}
//region block: exports
export {
  get_SaveBody as get_SaveBody3aignvhtsnvcr,
  get_isSaved as get_isSaved1yor47kvbhumv,
  skipSaveBody as skipSaveBodyqewhiekddpy3,
};
//endregion

//# sourceMappingURL=SaveBody.mjs.map
